import MultiSelectDropdown from '@/components/base/MultiSelectDropdown';
import SortToggle, { type SortKey } from '@/components/base/SortToggle';

interface FilterOption {
  value: string;
  label: string;
}

interface FilterBarProps {
  year: string[];
  onYearChange: (v: string[]) => void;
  projectType: string[];
  onProjectTypeChange: (v: string[]) => void;
  channel: string[];
  onChannelChange: (v: string[]) => void;
  subsidy: string[];
  onSubsidyChange: (v: string[]) => void;
  tradeMethod: string[];
  onTradeMethodChange: (v: string[]) => void;
  exchange: string[];
  onExchangeChange: (v: string[]) => void;
  province: string[];
  onProvinceChange: (v: string[]) => void;
  sort: SortKey;
  onSortChange: (v: SortKey) => void;
  onReset: () => void;
  totalCount: number;
  yearOptions: FilterOption[];
  projectTypeOptions: FilterOption[];
  channelOptions: FilterOption[];
  subsidyOptions: FilterOption[];
  tradeMethodOptions: FilterOption[];
  exchangeOptions: FilterOption[];
  provinceOptions: FilterOption[];
}

export default function FilterBar({
  year,
  onYearChange,
  projectType,
  onProjectTypeChange,
  channel,
  onChannelChange,
  subsidy,
  onSubsidyChange,
  tradeMethod,
  onTradeMethodChange,
  exchange,
  onExchangeChange,
  province,
  onProvinceChange,
  sort,
  onSortChange,
  onReset,
  totalCount,
  yearOptions,
  projectTypeOptions,
  channelOptions,
  subsidyOptions,
  tradeMethodOptions,
  exchangeOptions,
  provinceOptions,
}: FilterBarProps) {
  const hasFilter =
    year.length || projectType.length || channel.length || subsidy.length ||
    tradeMethod.length || exchange.length || province.length;

  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
      <div className="flex flex-col gap-3">
        {/* Row 1 */}
        <div className="flex items-center gap-2 flex-wrap">
          <MultiSelectDropdown placeholder="全部年份" options={yearOptions} value={year} onChange={onYearChange} />
          <MultiSelectDropdown placeholder="项目类型" options={projectTypeOptions} value={projectType} onChange={onProjectTypeChange} />
          <MultiSelectDropdown placeholder="通道" options={channelOptions} value={channel} onChange={onChannelChange} />
          <MultiSelectDropdown placeholder="补贴" options={subsidyOptions} value={subsidy} onChange={onSubsidyChange} />
          <MultiSelectDropdown placeholder="交易方式" options={tradeMethodOptions} value={tradeMethod} onChange={onTradeMethodChange} />
          <MultiSelectDropdown placeholder="交易所" options={exchangeOptions} value={exchange} onChange={onExchangeChange} />
          <MultiSelectDropdown placeholder="省份" options={provinceOptions} value={province} onChange={onProvinceChange} />

          {!!hasFilter && (
            <button
              onClick={onReset}
              className="px-3 py-2 text-sm text-accent-600 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
            >
              清除筛选
            </button>
          )}
        </div>

        {/* Sort + Count */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
          <span className="text-xs text-foreground-400 whitespace-nowrap">
            共 <strong className="text-foreground-700">{totalCount}</strong> 条
          </span>
          <SortToggle sort={sort} onSortChange={onSortChange} />
        </div>
      </div>
    </div>
  );
}
